<template>

  <div class="mt-2">
  <div class="badge-container">
    <div v-for="badge in badges" class="badge badge-info mr-1 mb-1 px-2 py-1" :key="badge.id">
      <div v-if="badge.valueFormatted" class="badge-content">
        <span class="mr-1">{{ badge.label }}: <span style="font-weight: bolder">{{ badge.valueFormatted }}</span></span>
        <span title="Remover" @click="clearBadge(badge)">
          <XIcon class="close-badge" size="1.5x"/>
        </span>
      </div>
    </div>
    </div>

    <template v-if="badges.length > 0">
      <div class="badge badge-remove-all badge-secondary mb-1 px-2 py-1"
           @click="clearAllBadges()">
        <div class="badge-content">
          Limpar filtros
        </div>
      </div>
    </template>

  </div>

</template>

<script>
  import { XIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  export default {
    components: { XIcon },
    computed: {
      badges() {
        const badges = []
        Object.entries(this.query).map(([key, value]) => {
          if (this.$utils.isEmpty(value, false))
            return

          if (key === 'generic') {
            badges.push(this.buildGenericBadge(value))
            return
          }

          const filter = this.filters.find(f => f instanceof Filter && f.key === key)
          if (!filter)
            return

          if (Array.isArray(value))
            value.forEach(v => badges.push(this.buildBadge(filter, key, v)))
          else
            badges.push(this.buildBadge(filter, key, value))
        })

        return this.organizeBadges(badges)
      }
    },
    data() {
      return {
        ids: []
      }
    },
    methods: {
      buildBadge(filter, key, value) {
        const valueFormatted = filter.valueFormatted(value)
        const id = `${filter.label}_${value}`
        const label = filter.label

        return { id, key, label, value, valueFormatted }
      },
      buildGenericBadge(value) {
        return {
          id: '1_generic',
          key: 'generic',
          label: 'Pesquisar por',
          value: value,
          valueFormatted: value
        }
      },
      clearAllBadges() {
        this.badges.forEach(badge => this.clearBadge(badge, false))
        this.$emit('clearAllBadges')
      },
      clearBadge(badge, sendEmit = true) {
        const value = this.query[badge.key]

        if (Array.isArray(value)) {
          this.query[badge.key] = value.filter(v => v !== badge.value)
        } else {
          this.query[badge.key] = ''
        }

        if (sendEmit)
          this.$emit('clearBadge', badge.key)
      },
      organizeBadges(badges) {
        const ids = []
        const newBadges = []

        badges.forEach(badge => {
          if (!ids.includes(badge.id)) {
            newBadges.push(badge)
            ids.push(badge.id)
          }
        })

        return newBadges.sort((a, b) => (a.id > b.id) ? 1 : (b.id > a.id) ? -1 : 0)
      }
    },
    name: 'BadgeFilters',
    props: {
      amountChanged: { type: Function },
      filters: { type: Array },
      query: { required: true, type: Object }
    },
    watch: {
      badges(value) {
        if (typeof this.amountChanged === 'function')
          this.amountChanged(value.length)
      }
    },
  }
</script>

<style scoped>
  .badge-container {
    overflow: auto;
    max-height: 120px;
  }
  .badge-info {
    background-color: #318BE3;
  }

  .badge-secondary {
    background-color: #898F95;
  }

  .badge-secondary:hover {
    background-color: #51565a;
  }

  .badge-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 18px;
  }

  .close-badge {
    cursor: pointer;
    opacity: 0.4;
    color: black;
  }

  .close-badge:hover {
    opacity: 1;
  }

  .badge-remove-all {
    cursor: pointer;
  }

</style>
